/**
 * Tiny glyph for the timeline node. Eight glyphs, one per
 * OperationMeta.glyph value, rendered through the central <Icon> system
 * (no inline SVG). Colour follows `currentColor` so the parent's tone
 * class (nodeSuccess / nodeError / …) controls the tint.
 */
import React from 'react';
import { Icon } from '../../../components/ui/Icon';

export type GlyphName =
  | 'flag'
  | 'bookmark'
  | 'plus'
  | 'upload'
  | 'pencil'
  | 'minus'
  | 'rewind'
  | 'refresh';

interface GlyphProps {
  name: GlyphName;
}

// Maps a timeline glyph name to a central <Icon> name.
const GLYPH_ICON: Record<GlyphName, string> = {
  flag: 'flag',
  bookmark: 'bookmark',
  plus: 'add',
  upload: 'upload',
  pencil: 'edit',
  minus: 'minus',
  rewind: 'rotate-ccw',
  refresh: 'refresh',
};

export default function Glyph({ name }: GlyphProps) {
  return <Icon name={GLYPH_ICON[name] || 'info'} size={16} />;
}
